import { Box, Container, Typography } from '@mui/material';

export function HomePage() {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            <Container
                maxWidth={false}
                sx={{
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    py: 4,
                }}>
                <Typography variant='h4' sx={{ color: '#002B5A', mb: 2 }}>
                    Welcome to CFRA Accessibility
                </Typography>
                <Typography variant='body1' sx={{ color: '#555' }}>
                    You are signed in. Application content will appear here.
                </Typography>
            </Container>
        </Box>
    );
}
